





























import { Component, Prop, Vue , Watch } from "vue-property-decorator";
import { Const } from "@/const";

@Component({
  components: {
  },
})
export default class SaveButton extends Vue {
    @Prop() private userConfigColor! : string;
}
